import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';
import { url } from '../Constent/Constant';

const Quote = ({ SectionData, SubHeading, UpdateText, UpdateImage,  btnText }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextUpdate, setTextUpdate] = useState('')
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [TextModal, setTextModal] = useState(false);
    const [ImageModal, setImageModal] = useState(false);
    const [TextId, setTextId] = useState('')
    const [ImageId, setImageId] = useState('')

    console.log(SectionData)

    const showTextModal = (id) => {
        setTextModal(true);
        setTextId(id)
    };

    const showImageModal = (id) => {
        setImageModal(true);
        setImageId(id)
    };

    const OnTextHandle = () => {
        if (TextUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: TextUpdate,
                id: TextId
            })
            setTextModal(false);
            setTextUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: ImageId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModal(false);
        setImageModal(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if(event.key === 'Enter'){
          console.log('Enter Clicked')
          a.concat('\n')
          setHeadingUpdate(a)
        }else{
          console.log(event.key)
        }
      }    

    return (
        <div className='Quote-sec'>
            <div className='Quote-info'>
                <p className='info-subheading'> {SubHeading ? SubHeading : ''}
                    <i onClick={() => showTextModal(SectionData.SubHeadingId)} className="far fa-edit Edit-btn"></i>
                </p>
                <h2 className='Heading'> {SectionData ? SectionData.heading : ''}
                    <i onClick={() => showTextModal(SectionData.headingId)} className="far fa-edit Edit-btn"></i>
                </h2>
                <div className='Edit-div'>
                    <i onClick={() => showTextModal(SectionData.para1Id)} className="far fa-edit Edit-btn"></i>
                    <div className='Quote-list'>
                        <p className='Quote-para'> {SectionData ? SectionData.para1 : ''}
                        </p>
                    </div>
                </div>
                {btnText ? (
                    <a  href="tel: 844-346-2264"> <button className='Primary-btn Button'>{btnText}</button>
                    </a>
                ) : (
                    <button className='Primary-btn Button'>GET A QUOTE</button>
                ) }
            </div>
            <div className='Quote-img'>
                <img src={`${url}/api/getFile${SectionData.image}`} alt='Quote' draggable='false' />
                <i onClick={() => showImageModal(SectionData.imageId)} className="far fa-edit Edit-btn"></i>
            </div>

            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Text' visible={TextModal} onOk={OnTextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e)=> OnEnterPress(e)} value={TextUpdate} onChange={e => setTextUpdate(e.target.value)} className='Input' placeholder='Update Text...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>
        </div>
    )
}

export default Quote
